import { Text } from '../../atoms/Text';
import { Stack } from '../../atoms/Stack';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface EmptyStateProps extends CoreProps {
  title: string;
  description?: string;
}

export function EmptyState({ title, description, testId, view = 'all' }: EmptyStateProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return (
    <Stack align="center" py="xl" gap="xs" data-testid={testId}>
      <Text fw={600}>{title}</Text>
      {description ? (
        <Text c="dimmed" size="sm">
          {description}
        </Text>
      ) : null}
    </Stack>
  );
}
